import { jsxs as D, jsx as n } from "react/jsx-runtime";
import { Loader as U } from "@systemeio/ui";
import { useVirtualizer as P } from "../../../node_modules/@tanstack/react-virtual/dist/esm/index.mjs";
import V, { useState as p, useEffect as x } from "react";
import { isDataFileInterface as Y } from "../../../libs/types/dist/index7.mjs";
import { FileCard as Z } from "../../../components/file-card/index.mjs";
import { FileActionMenuDetailsItem as $, FileActionMenuDeleteItem as G, FileActionMenuRenameItem as ee, FileActionMenuDownloadItem as te } from "../../../components/file-action-menu-item/index.mjs";
const z = 2, re = 6, ne = z * 2 + re;
function de({
  initialItemWidth: m = 150,
  initialItemHeight: v = 180,
  rowGap: b = 18,
  columnGap: c = 16,
  columnCount: L = 6,
  dataFilesApi: W,
  specialElementInGrid: I,
  onSelect: C,
  onDetails: F,
  onDelete: S,
  onRename: A,
  onDownload: E
}) {
  var _;
  const s = V.useRef(null), d = V.useRef(null), [i, j] = p(L), [o, B] = p(m), [a, H] = p(v), [y, X] = p(), { data: M, fetchNextPage: T, hasNextPage: N, isFetchingNextPage: f, isFetching: q } = W, h = "specialElementInGridId", w = I ? i >= 2 ? [h, h] : [h] : [], R = [...w, ...((_ = M == null ? void 0 : M.pages) == null ? void 0 : _.flatMap((t) => t.items)) ?? []], J = R.length;
  x(() => {
    const t = () => {
      if (s.current) {
        const l = s.current.offsetWidth - ne, e = Math.floor(l / (m + c));
        j(e || 1);
        const u = (l - c * (e - 1)) / e;
        B(u), H(u / m * v);
      }
    };
    t();
    const r = new ResizeObserver(t);
    return s.current && r.observe(s.current), () => r.disconnect();
  }, [m, v, c]);
  const k = P({
    count: Math.ceil(J / i),
    gap: b,
    getScrollElement: () => s.current,
    estimateSize: () => a
  }), O = P({
    count: i,
    gap: c,
    getScrollElement: () => s.current,
    estimateSize: () => o,
    horizontal: !0
  });
  return x(() => {
    if (!d.current || !N || f) return;
    const t = new IntersectionObserver(
      (r) => {
        r[0].isIntersecting && T();
      },
      { root: s.current, threshold: 0.1 }
    );
    return t.observe(d.current), () => {
      d.current && t.unobserve(d.current);
    };
  }, [T, N, f]), x(() => {
    const t = R.filter(Y).find((r) => r.id === y);
    C == null || C(t);
  }, [y]), /* @__PURE__ */ D(
    "div",
    {
      ref: s,
      className: "customScroll relative h-[400px] w-full overflow-auto",
      style: { paddingTop: z, paddingLeft: z },
      children: [
        /* @__PURE__ */ D(
          "div",
          {
            style: {
              height: k.getTotalSize(),
              width: O.getTotalSize()
            },
            className: "relative",
            children: [
              q && !f ? Array.from({ length: 10 }).map((t, r) => /* @__PURE__ */ n(
                "div",
                {
                  className: "bg-background-tertiary absolute animate-pulse rounded-md",
                  style: {
                    top: Math.floor(r / i) * (a + b),
                    left: r % i * (o + c),
                    height: a,
                    width: o
                  }
                },
                r
              )) : k.getVirtualItems().map(
                (t) => O.getVirtualItems().map((r) => {
                  const l = t.index * i + r.index, e = R[l];
                  if (!e) return null;
                  let u = Math.floor(l / i) * (a + b);
                  const K = l % i * (o + c);
                  let g = 0;
                  switch (i) {
                    case 1:
                      g = 180;
                      break;
                    case 2:
                      g = 80;
                      break;
                  }
                  return I && (u = u - g), h === e ? l === 0 ? /* @__PURE__ */ n(
                    "div",
                    {
                      style: {
                        top: 0,
                        left: 0,
                        height: a - g,
                        width: o * w.length + c * (w.length - 1)
                      },
                      children: I
                    },
                    e + l
                  ) : null : /* @__PURE__ */ n(
                    Z,
                    {
                      src: e.thumbnail ?? e.path ?? void 0,
                      alt: e.name,
                      name: e.name,
                      imageWidth: o,
                      imageHeight: o * 0.869,
                      secondaryText: e.type,
                      fileType: e.type,
                      style: {
                        top: u,
                        left: K,
                        height: a,
                        width: o
                      },
                      selected: y === e.id,
                      onSelect: (Q) => {
                        X(Q ? e.id : void 0);
                      },
                      className: "absolute",
                      actionMenu: {
                        menuItems: [
                          F ? /* @__PURE__ */ n(
                            $,
                            {
                              onClick: () => F(e)
                            },
                            "details"
                          ) : void 0,
                          S ? /* @__PURE__ */ n(
                            G,
                            {
                              onClick: () => S(e)
                            },
                            "delete"
                          ) : void 0,
                          A ? /* @__PURE__ */ n(
                            ee,
                            {
                              onClick: () => A(e)
                            },
                            "rename"
                          ) : void 0,
                          E ? /* @__PURE__ */ n(
                            te,
                            {
                              onClick: () => E(e)
                            },
                            "download"
                          ) : void 0
                        ].filter(Boolean)
                      }
                    },
                    e.id
                  );
                })
              ),
              N && /* @__PURE__ */ n("div", { ref: d, className: "absolute bottom-0" })
            ]
          }
        ),
        /* @__PURE__ */ n("div", { className: "flex h-11 w-full items-center justify-center pt-4", children: f && /* @__PURE__ */ n(U, {}) })
      ]
    }
  );
}
export {
  de as FileGrid
};
